import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SiteContext = createContext(null);

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setLoading(true);
    api
      .get("/site")
      .then(({ data }) => setMeta(data))
      .catch(() => setMeta({ nav: [], id_slug: {}, id_title: {} }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refresh();
  }, []);

  // Resolve a notion page id (dashless) -> internal route
  const resolveRef = (pageRef) => {
    if (!meta || !pageRef) return null;
    const slug = meta.id_slug?.[pageRef];
    if (!slug) return null;
    const navItem = (meta.nav || []).find((n) => n.slug === slug);
    if (navItem?.is_home) return "/";
    return `/p/${slug}`;
  };

  const resolvePageTitle = (pageRef) => {
    if (!meta || !pageRef) return null;
    if (meta.id_title?.[pageRef]) return meta.id_title[pageRef];
    const slug = meta.id_slug?.[pageRef];
    if (!slug) return null;
    const navItem = (meta.nav || []).find((n) => n.slug === slug);
    return navItem?.title || null;
  };

  return (
    <SiteContext.Provider value={{ meta, loading, refresh, resolveRef, resolvePageTitle }}>
      {children}
    </SiteContext.Provider>
  );
};
